import { matchIsValidTel } from 'mui-tel-input';
import { phoneRegex } from 'utils/regexes';

/**
 * האם המספר שהוקלד יתקבל ע"י השרת.
 *
 * מיישר קו עם שתי הוולידציות בצד השרת: FormatAndValidateIsraelMobilePhoneNumber
 * ב-server3 (היעד של CreateChatUser) ו-validateInternationalPhoneE164 בשרת הנוד.
 * שתיהן מקבלות נייד ישראלי מקומי (05X) וכל מספר בינלאומי תקין, בלי קשר למדינת
 * מספר הוואטסאפ של החברה.
 *
 * עד 11.2026 דיאלוג יצירת איש הקשר בדק מול מדינת החברה בלבד: לחברה ישראלית נבדק
 * רק 05X, ולחברה אחרת רק המדינה שלה. התוצאה הייתה שאי אפשר היה ליצור איש קשר עם
 * מספר מחו"ל, למרות שהשרת מקבל אותו.
 *
 * קידומת 00 (הצורה שבה חלק מה-CRM שומרים מספר בינלאומי) נדחית כאן במכוון, כי גם
 * שני השרתים דוחים אותה — אין טעם לשלוח בקשה שתיכשל.
 */
export function isValidContactPhoneInput(rawValue: string | undefined | null): boolean {
  const value = (rawValue ?? '').trim();
  if (!value) return false;

  //* נייד ישראלי מקומי — השרת מנרמל אותו ל-972
  if (phoneRegex.test(value)) return true;

  //* בינלאומי: libphonenumber צריך צורה בינלאומית כדי לזהות את המדינה
  const compact = value.replace(/[\s()\-.]/g, '');
  if (!/^\+?\d{7,15}$/.test(compact)) return false;

  return matchIsValidTel(compact.startsWith('+') ? compact : `+${compact}`);
}

export default isValidContactPhoneInput;
